export default import.meta.ROLLUP_FILE_URL_u8dwExjqzeY4cJJNvlCo1w